import { render } from "./Manufacturer.vue?vue&type=template&id=ced4ac46&scoped=true"
import script from "./Manufacturer.vue?vue&type=script&lang=js"
export * from "./Manufacturer.vue?vue&type=script&lang=js"

import "./Manufacturer.vue?vue&type=style&index=0&id=ced4ac46&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ced4ac46"]])

export default __exports__